import { BackendError } from './base';

class BondDoesNotExist extends BackendError {}

export default {
    BondDoesNotExist,
};
